import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import InputMask from "react-input-mask";
import { Plus, Trash2 } from "react-feather";

import practicePocTypes from "../../utils/practicePocTypes";

// Edits the practice's points of contact. Calls onChange with the full updated list on every edit.
const PracticePocsEditor = ({ pocs, onChange }) => {
  const [rows, setRows] = useState(pocs || []);

  const update = (newRows) => {
    setRows(newRows);
    onChange(newRows);
  };

  const handleFieldChanged = (index, name, value) => {
    update(rows.map((row, i) => (i === index ? { ...row, [name]: value } : row)));
  };

  const handleAdd = () => {
    update([...rows, { id: null, practicePocType: "OFFICE_MANAGER", firstName: "", lastName: "", email: "", phone: "" }]);
  };

  const handleRemove = (index) => {
    update(rows.filter((row, i) => i !== index));
  };

  return (
    <div>
      {rows.length === 0 && <div className="text-muted mb-2">No points of contact</div>}
      {rows.map((row, index) => (
        <div key={row.id == null ? "new-" + index : row.id} className="border rounded p-2 mb-2">
          <Row className="mb-2">
            <Col>
              <Form.Select size="sm" value={row.practicePocType || "OTHER"} onChange={(e) => handleFieldChanged(index, "practicePocType", e.target.value)}>
                {practicePocTypes.map((type) => <option key={type.value} value={type.value}>{type.label}</option>)}
              </Form.Select>
            </Col>
            <Col xs="auto">
              <Button size="sm" variant="outline-danger" title="Remove contact" onClick={() => handleRemove(index)}><Trash2 size={14} /></Button>
            </Col>
          </Row>
          <Row className="mb-2">
            <Col><Form.Control size="sm" placeholder="First name" value={row.firstName || ""} onChange={(e) => handleFieldChanged(index, "firstName", e.target.value)} /></Col>
            <Col><Form.Control size="sm" placeholder="Last name" value={row.lastName || ""} onChange={(e) => handleFieldChanged(index, "lastName", e.target.value)} /></Col>
          </Row>
          <Row>
            <Col>
              <InputMask mask="(999) 999-9999" value={row.phone || ""} onChange={(e) => handleFieldChanged(index, "phone", e.target.value)}>
                {(inputProps) => <Form.Control size="sm" type="tel" placeholder="Phone" {...inputProps} />}
              </InputMask>
            </Col>
            <Col><Form.Control size="sm" placeholder="Email" value={row.email || ""} onChange={(e) => handleFieldChanged(index, "email", e.target.value)} /></Col>
          </Row>
        </div>
      ))}
      <Button size="sm" variant="outline-primary" onClick={handleAdd}><Plus size={14} /> Add contact</Button>
    </div>
  );
};

export default PracticePocsEditor;
